angular.module('qkr.inventory').factory('variantService', (utils, variantDefinitionService,
                                                           variantInfrastructureService, variantHelperService,
                                                           gettextCatalog) => {
    const variantSetActions = {
        DELETE: 'DELETE',
        CREATE: 'CREATE',
        MODIFY: 'MODIFY',
        REORDER: 'REORDER'
    };

    const variantSetOptionActions = {
        DELETE: 'DELETE',
        CREATE: 'CREATE',
        REORDER: 'REORDER'
    };

    const sortResultsArray = function(variantTypeA, variantTypeB) {
        const textA = variantTypeA.text.trim().toLowerCase();
        const textB = variantTypeB.text.trim().toLowerCase();

        // Sort string ascending
        if (textA < textB) {
            return -1;
        }

        if (textA > textB) {
            return 1;
        }

        return 0;
    };

    const getValidVariantSets = function(variantSets) {
        const validVariantSets = [];
        angular.forEach(variantSets, (variantSet) => {
            if (variantSet.variantType != null) {
                validVariantSets.push(variantSet);
            }
        });
        return validVariantSets;
    };

    const variantSetOptionsHaveChanged = function(pairedVariantSets) {
        if (pairedVariantSets.old.options.length != pairedVariantSets.new.options.length) {
            return true;
        } else {
            for (let i = 0; i < pairedVariantSets.old.options.length; i++) {
                // Order of options must be the same, so use the same index
                const oldVariantSetOption = pairedVariantSets.old.options[i];
                const newVariantSetOption = pairedVariantSets.new.options[i];

                if (oldVariantSetOption != newVariantSetOption) {
                    return true;
                }
            }
        }
        return false;
    };

    const findUnpairedVariantSets = function(variantSets, pairedVariantSets) {
        const unPairedEntries = [];

        // Check if the variantSets have been matched, if not add it to the paired list
        for (let i = 0; i < variantSets.length; i++) {
            const variantSet = variantSets[i];
            let alreadyPaired = false;

            for (let j = 0; j < pairedVariantSets.length; j++) {
                const pairedVariantSet = pairedVariantSets[j];

                if (pairedVariantSet.old == variantSet || pairedVariantSet.new == variantSet) {
                    alreadyPaired = true;
                    break;
                }
            }

            if (!alreadyPaired) {
                unPairedEntries.push(variantSet);
            }
        }

        return unPairedEntries;
    };

    const createPairedVariantSet = function(oldVariantSet, newVariantSet, reordered, index) {
        return {
            old: oldVariantSet,
            new: newVariantSet,
            reordered,
            index
        };
    };

    const pairOldAndNewVariantSets = function(oldVariantSets, newVariantSets) {
        // Loop around the biggest list and keep the pairs in order, even if they don't have pairs
        const pairedVariantSets = [];

        const variantSetDeleted = oldVariantSets.length > newVariantSets.length;
        const masterVariantSets = variantSetDeleted ? oldVariantSets : newVariantSets;
        const slaveVariantSets = variantSetDeleted ? newVariantSets : oldVariantSets;

        for (let index = 0; index < masterVariantSets.length; index++) {
            const masterVariantSet = masterVariantSets[index];
            var slaveVariantSet = null;

            if (index < slaveVariantSets.length) {
                slaveVariantSet = slaveVariantSets[index];
            }

            // Check that they are the same
            if (slaveVariantSet != null && masterVariantSet.variantType.id == slaveVariantSet.variantType.id) {
                var oldVariantSet = variantSetDeleted ? masterVariantSet : slaveVariantSet;
                var newVariantSet = variantSetDeleted ? slaveVariantSet : masterVariantSet;

                pairedVariantSets.push(createPairedVariantSet(oldVariantSet, newVariantSet, false, index));
                continue;
            }

            let found = false;

            // We haven't found a match - look for it somewhere in the slave array
            for (let j = 0; j < slaveVariantSets.length; j++) {
                var slaveVariantSet = slaveVariantSets[j];
                if (slaveVariantSet.variantType.id == masterVariantSet.variantType.id) {
                    var oldVariantSet = variantSetDeleted ? masterVariantSet : slaveVariantSet;
                    var newVariantSet = variantSetDeleted ? slaveVariantSet : masterVariantSet;

                    pairedVariantSets.push(createPairedVariantSet(oldVariantSet, newVariantSet, true, index));
                    found = true;
                    break;
                }
            }

            if (!found) {
                // Still not found - must be an orphaned variantSet
                var oldVariantSet = variantSetDeleted ? masterVariantSet : null;
                var newVariantSet = variantSetDeleted ? null : masterVariantSet;
                pairedVariantSets.push(createPairedVariantSet(oldVariantSet, newVariantSet, false, index));
            }
        }

        return pairedVariantSets;
    };

    const pairedVariantSetDeltasExist = function(pairedVariantSetDeltas) {
        if (pairedVariantSetDeltas != null) {
            if (!utils.hasNoValue(pairedVariantSetDeltas.deleted) || !utils.hasNoValue(pairedVariantSetDeltas.created)
                    || !utils.hasNoValue(pairedVariantSetDeltas.modified) || !utils.hasNoValue(pairedVariantSetDeltas.reordered)) {
                return true;
            }
        }

        return false;
    };

    const getPairedVariantSetDeltas = function(pairedVariantSets) {
        const pairedVariantSetDeltas = {
            deleted: [],
            created: [],
            modified: [],
            reordered: []
        };

        angular.forEach(pairedVariantSets, (pairedVariantSet) => {
            if (pairedVariantSet.new == null) {
                pairedVariantSetDeltas.deleted.push(pairedVariantSet);
            } else if (pairedVariantSet.old == null) {
                pairedVariantSetDeltas.created.push(pairedVariantSet);
            } else if (variantSetOptionsHaveChanged(pairedVariantSet)) {
                    pairedVariantSetDeltas.modified.push(pairedVariantSet);
                } else if (pairedVariantSet.reordered) {
                    pairedVariantSetDeltas.reordered.push(pairedVariantSet);
                }
        });
        return pairedVariantSetDeltas;
    };

    const findAndRemoveOptionFromArray = function(optionArray, optionToRemove) {
        for (let i = 0; i < optionArray.length; i++) {
            if (optionArray[i] == optionToRemove) {
                optionArray.splice(i, 1);
                return true;
            }
        }

        return false;
    };

    const validateDislocatedOption = function(pairedVariantSets, potentialDislocatedOption) {
        // Make copies of both old and new arrays, remove the potentialDislocatedOption and compare the arrays again.
        // If they are in order, we have the dislocatedOption
        const oldVariantSetOptions = utils.copyArray(pairedVariantSets.old.options);
        const newVariantSetOptions = utils.copyArray(pairedVariantSets.new.options);

        const foundOldOption = findAndRemoveOptionFromArray(oldVariantSetOptions, potentialDislocatedOption);
        const foundNewOption = findAndRemoveOptionFromArray(newVariantSetOptions, potentialDislocatedOption);

        if (!foundNewOption) {
            // This opion has already been deleted and is therefore the dislocated option
            return true;
        } else {
            // Compare the arrays
            for (let i = 0; i < newVariantSetOptions.length; i++) {
                const newVariantSetOption = newVariantSetOptions[i];
                const oldVariantSetOption = oldVariantSetOptions[i];

                if (newVariantSetOption != oldVariantSetOption) {
                    return false;
                }
            }

            // All options in the arrays have matched so this is the dislocated option
            return true;
        }

        return false;
    };

    const getIndexOfDislocatedVariantSetOption = function(pairedVariantSets) {
        // Loop around the biggest array so we don't go out of bounds
        let loopArray = pairedVariantSets.new.options;

        if (pairedVariantSets.old.options.length > pairedVariantSets.new.options.length) {
            // More old options than new - deletion has occurred
            loopArray = pairedVariantSets.old.options;
        }

        // Sets should be the same up to the dislocated option.
        for (let index = 0; index < loopArray.length; index++) {
            const oldVariantSetOption = (index == pairedVariantSets.old.options.length) ? null : pairedVariantSets.old.options[index];
            const newVariantSetOption = (index == pairedVariantSets.new.options.length) ? null : pairedVariantSets.new.options[index];

            if (oldVariantSetOption == null || newVariantSetOption == null) {
                return index;
            }

            if (oldVariantSetOption != newVariantSetOption) {
                // In the case of a reorder, the dislocated option is the one that moved which is not necessarily the first one that is out of place.
                // We need to compare the rest of the array to ensure parity.
                // Remove the dislocated option and check the rest of the array

                if (validateDislocatedOption(pairedVariantSets, loopArray[index])) {
                    return index;
                }
            }
        }

        return null;
    };

    const getActionForVariantSetOptionDelta = function(pairedVariantSets) {
        const variantSet = pairedVariantSets.new;
        const variantSetIndex = pairedVariantSets.index;

        const indexOfDislocatedOption = getIndexOfDislocatedVariantSetOption(pairedVariantSets);
        let dislocatedOption = null;
        let action = null;

        if (pairedVariantSets.old.options.length == pairedVariantSets.new.options.length) {
            action = variantSetOptionActions.REORDER;
            dislocatedOption = pairedVariantSets.new.options[indexOfDislocatedOption];
        } else if (pairedVariantSets.old.options.length < pairedVariantSets.new.options.length) {
            action = variantSetOptionActions.CREATE;
            dislocatedOption = pairedVariantSets.new.options[indexOfDislocatedOption];
        } else {
            action = variantSetOptionActions.DELETE;
            dislocatedOption = pairedVariantSets.old.options[indexOfDislocatedOption];
        }

        return new variantDefinitionService.VariantSetOptionDeltaAction(action, variantSet, variantSetIndex, dislocatedOption, indexOfDislocatedOption);
    };

    const getActionsForPairedVariantSetDeltas = function(pairedVariantSetDeltas) {
        const actions = [];

        angular.forEach(pairedVariantSetDeltas.deleted, (pairedVariantSets) => {
            const action = new variantDefinitionService.VariantSetDeltaAction(variantSetActions.DELETE, pairedVariantSets.old, pairedVariantSets.index, null);
            actions.push(action);
        });

        angular.forEach(pairedVariantSetDeltas.created, (pairedVariantSets) => {
            const action = new variantDefinitionService.VariantSetDeltaAction(variantSetActions.CREATE, pairedVariantSets.new, pairedVariantSets.index, null);
            actions.push(action);
        });

        angular.forEach(pairedVariantSetDeltas.modified, (pairedVariantSets) => {
            const variantSetOptionDeltaAction = getActionForVariantSetOptionDelta(pairedVariantSets);
            const action = new variantDefinitionService.VariantSetDeltaAction(variantSetActions.MODIFY, pairedVariantSets.new, pairedVariantSets.index, variantSetOptionDeltaAction);
            actions.push(action);
        });

        angular.forEach(pairedVariantSetDeltas.reordered, (pairedVariantSets) => {
            const action = new variantDefinitionService.VariantSetDeltaAction(variantSetActions.REORDER, pairedVariantSets.new, pairedVariantSets.index, null);
            actions.push(action);
        });

        return actions;
    };

    const executeVariantActionsOnProduct = function(variantInfrastructure, skusInUse, product, actions) {
        let newVariantDefinitions = (product.variants != null) ? utils.copyArray(product.variants) : [];

        angular.forEach(actions, (action) => {
            newVariantDefinitions = action.execute(variantInfrastructure, skusInUse, product, newVariantDefinitions);
        });

        return newVariantDefinitions;
    };

    const createValidationResult = function() {
        const validationResult = {
            valid: true,
            errors: []
        };

        return validationResult;
    };

    return {
        getValidVariantSets(variantSets) {
            return getValidVariantSets(variantSets);
        },

        getVariantInfrastructure(variants, maxVariants) {
            return variantInfrastructureService.getVariantInfrastructure(variants, maxVariants);
        },

        getVariantSetsFromInfrastructure(variantInfrastructure) {
            return variantInfrastructureService.extractVariantSetsFromInfrastructure(variantInfrastructure);
        },

        getVariantsFromInfrastructure(variantInfrastructure) {
            return variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);
        },

        getVariantRemovalListFromInfrastructure(variantInfrastructure) {
            return variantInfrastructureService.extractVariantRemovalListFromInfrastructure(variantInfrastructure);
        },

        getVariantDetailRemovalListFromInfrastructure(variantInfrastructure) {
            return variantInfrastructureService.extractVariantDetailRemovalListFromInfrastructure(variantInfrastructure);
        },

        getVariantTypesFromInfrastructure(variantInfrastructure) {
            return variantInfrastructureService.extractVariantTypesFromInfrastructure(variantInfrastructure);
        },

        getVariantTitleListFromInfrastructure(variantInfrastructure) {
            return variantInfrastructureService.extractVariantTitleListFromInfrastructure(variantInfrastructure);
        },

        getSelectVariantConfig(variantInfrastructure) {
            const variantTypes = variantInfrastructureService.extractVariantTypesFromInfrastructure(variantInfrastructure);

            return {
                multiple: false,
                formatNoMatches: '',
                initSelection(element, callback) {
                    let selectedVariantType = null;

                    angular.forEach(variantTypes, (variantType) => {
                        if (variantType.text.toLowerCase() == element.val().toLowerCase()) {
                            selectedVariantType = variantType;
                        }
                    });

                    if (selectedVariantType == null) {
                        selectedVariantType = {
                            id: variantTypes.length,
                            text: element.val(),
                            disabled: false
                        };

                        variantTypes.push(selectedVariantType);
                    }

                    callback(selectedVariantType);
                },
                query(query) {
                    const data = {
                        results: []
                    };
                    let newVariantType = query.term;

                    if (newVariantType != '') {
                        // If the new variant type matches an existing one,
                        // Don't add it.
                        let foundExactMatch = false;

                        angular.forEach(variantTypes, (existingVariantType) => {
                            if (existingVariantType.text.substring(0, newVariantType.length).trim().toLowerCase() == newVariantType.trim().toLowerCase()) {
                                // Add matching existing items to results
                                data.results.push(existingVariantType);

                                // If both lengths are equal, then it's an exact match.
                                if (newVariantType.trim().toLowerCase().length == existingVariantType.text.trim().toLowerCase().length) {
                                    foundExactMatch = true;
                                }
                            }
                        });

                        data.results.sort(sortResultsArray);

                        if (!foundExactMatch) {
                            newVariantType = newVariantType.trim() + ' ' + variantInfrastructureService.getCreateNewVariantTypeMarkerText();
                            data.results.unshift({
                                id: variantTypes.length,
                                text: newVariantType,
                                disabled: false,
                                justCreated: true
                            });
                        }
                    } else {
                        // Add all existing variant types
                        angular.forEach(variantTypes, (existingVariantType) => {
                            const variantType = {
                                id: existingVariantType.id,
                                text: existingVariantType.text,
                                disabled: existingVariantType.disabled
                            };
                            data.results.push(variantType);
                        });

                        data.results.sort(sortResultsArray);
                    }

                    query.callback(data);
                }
            };
        },

        getDefineVariantConfig(variantInfrastructure) {
            return {
                multiple: true,
                simple_tags: true,
                tags: [],
                tokenSeparators: [','],
                formatNoMatches: '',
                dropdownCssClass: 'select2-container-multi-variantOption-dropdownCssClass'
            };
        },

        sortVariants(variantA, variantB) {
            if (variantA.priority < variantB.priority) {
                return -1;
            }
            if (variantA.priority > variantB.priority) {
                return 1;
            }
            return 0;
        },

        productHasSystemDefaultVariant(product) {
            return product.variants.length == 1 && product.variants[0].variantDetails.length == 0;
        },

        buildVariants(variantInfrastructure, skusInUse, product, oldVariantSets, newVariantSets) {
            const oldValidVariantSets = getValidVariantSets(oldVariantSets);
            const newValidVariantSets = getValidVariantSets(newVariantSets);

            const pairedVariantSets = pairOldAndNewVariantSets(oldValidVariantSets, newValidVariantSets);
            const pairedVariantSetDeltas = getPairedVariantSetDeltas(pairedVariantSets);

            if (pairedVariantSetDeltasExist(pairedVariantSetDeltas)) {
                const actions = getActionsForPairedVariantSetDeltas(pairedVariantSetDeltas);

                if (actions != null && actions.length > 0) {
                    return executeVariantActionsOnProduct(variantInfrastructure, skusInUse, product, actions);
                }
            }

            return null;
        },

        addNewVariant(variantInfrastructure, newVariant) {
            const variantDetails = [];
            angular.forEach(newVariant.variantDetails, (newVariantDetail) => {
                const variantDetail = variantInfrastructureService.createNewVariantDetail(true, newVariantDetail.variantLabel, newVariantDetail.variantValue, null);
                variantInfrastructureService.setOptionColourOnVariantDetail(variantInfrastructure, variantDetail);
                variantDetails.push(variantDetail);
            });

            const variant = variantInfrastructureService.createNewVariant(newVariant.amountMinorUnits, newVariant.sku, newVariant.stockQuantity, true, false, variantDetails);
            variantInfrastructureService.addNewVariant(variantInfrastructure, variant);
        },

        removeVariant(variantInfrastructure, skusInUse, removeVariant) {
            variantInfrastructureService.removeVariant(variantInfrastructure, skusInUse, removeVariant);
        },

        changeVariantType(variantInfrastructure, oldVariantTypeText, newVariantTypeText) {
            variantInfrastructureService.changeVariantType(variantInfrastructure, oldVariantTypeText, newVariantTypeText);
        },

        changeDefaultStockQuantity(variantInfrastructure, oldDefaultStockQuantity, newDefaultStockQuantity) {
            variantInfrastructureService.changeDefaultStockQuantity(variantInfrastructure, oldDefaultStockQuantity, newDefaultStockQuantity);
        },

        isVariantUnique(variantInfrastructure, newVariant) {
            const validationResult = createValidationResult();
            const variants = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);

            for (let variantIndex = 0; variantIndex < variants.length; variantIndex++) {
                const variant = variants[variantIndex];
                let matches = 0;

                if (!utils.hasNoValue(variant.sku) && !utils.hasNoValue(newVariant.sku) && newVariant.sku.toLowerCase() == variant.sku.toLowerCase()) {
                    const skuErrorText = gettextCatalog.getString('Skus must be unique.');

                    validationResult.valid = false;
                    validationResult.errors.push({errorCode: 'sku', errorText: skuErrorText, errorObject: newVariant.sku});
                }

                for (let variantDetailIndex = 0; variantDetailIndex < variant.variantDetails.length; variantDetailIndex++) {
                    const existingVariantDetail = variant.variantDetails[variantDetailIndex];
                    let newVariantDetail = null;

                    for (let newVariantDetailIndex = 0; newVariantDetailIndex < newVariant.variantDetails.length; newVariantDetailIndex++) {
                        const variantDetail = newVariant.variantDetails[newVariantDetailIndex];
                        if (existingVariantDetail.variantLabel == variantDetail.variantLabel) {
                            newVariantDetail = variantDetail;
                            break;
                        }
                    }

                    if (existingVariantDetail.variantValue.toLowerCase() == newVariantDetail.variantValue.toLowerCase()) {
                        matches++;
                    }
                }

                if (matches == variant.variantDetails.length) {
                    const variantDetailsErrorText = gettextCatalog.getString('Variants must be unique.');
                    validationResult.valid = false;
                    validationResult.errors.push({errorCode: 'variantDetails', errorText: variantDetailsErrorText, errorObject: newVariant.variantDetails});
                }
            }

            return validationResult;
        },

        validateVariant(variant, stockTrackingEnabled) {
            const validationResult = createValidationResult();

            for (let i = 0; i < variant.variantDetails.length; i++) {
                const variantDetail = variant.variantDetails[i];

                if (utils.hasNoValue(variantDetail.variantValue) || variantDetail.variantValue.length == 0) {
                    const variantDetailValueErrorText = gettextCatalog.getString('All variant fields must have a value.');

                    validationResult.valid = false;
                    validationResult.errors.push({errorCode: 'variantDetailValue', errorText: variantDetailValueErrorText, errorObject: variant.variantDetails});
                    break;
                }
            }

            if (stockTrackingEnabled) {
                if (utils.hasNoValue(variant.stockQuantity)) {
                    const stockErrorText = gettextCatalog.getString('Variants must have a valid stock quantity.');

                    validationResult.valid = false;
                    validationResult.errors.push({errorCode: 'stock', errorText: stockErrorText, errorObject: variant});
                }
            }

            if (utils.hasNoValue(variant.amountMinorUnits) || variant.amountMinorUnits < 0) {
                const priceErrorText = gettextCatalog.getString('Variants must have a valid price.');

                validationResult.valid = false;
                validationResult.errors.push({errorCode: 'amountMinorUnits', errorText: priceErrorText, errorObject: variant});
            }

            return validationResult;
        },

        variantSetsHaveChanged(variantInfrastructure, variantSets) {
            const validVariantSets = getValidVariantSets(variantSets);
            return variantInfrastructureService.variantSetsHaveChanged(variantInfrastructure, validVariantSets);
        },

        removeAppendedCreateNewVariantTypeMarkerText(text) {
            // Find the last index of the marker text and remove it if it exists
            const createNewMarkerText = variantInfrastructureService.getCreateNewVariantTypeMarkerText();
            const lastIndex = text.lastIndexOf(createNewMarkerText);
            let resultText = text;
            if (lastIndex > -1) {
                resultText = text.substring(0, lastIndex).trim();
            }

            return resultText;
        },

        getNextAvailableOptionColour(variantSets) {
            return variantHelperService.getNextAvailableOptionColourForVariantSets(variantSets);
        },

        generateVariantSetId(variantSets, variantInfrastructure) {
            return variantHelperService.generateVariantSetId(variantSets, variantInfrastructure);
        }
    };
});



// WEBPACK FOOTER //
// ./src/inventory/services/variant.services.js